
export let Config = {
    env: "prod",
    staging: {
        functionappurl: "https://sitecreator5.azurewebsites.net/",
        // functionappurl: "https://sitecreatorv2.azurewebsites.net/",
        appurl: "https://dasitecreator.z16.web.core.windows.net/"
    },
    dev: {
        functionappurl: "http://localhost:7071/",
        appurl: "http://localhost:3000"
    },
    prod: {
        functionappurl: "https://da-site-creatorv2.azurewebsites.net/",
        appurl: "https://sitecreatorstorage.z16.web.core.windows.net/"
    },
    test: {
        functionappurl: "https://sitecreatortest.azurewebsites.net/",
        appurl: "https://sitecreatortest.z22.web.core.windows.net/"
    }
}


// WEBPACK FOOTER //
// ./src/config.js